import { createCachedSelector, path, prop } from '@cbridge-utils/redux';
import { createDefaultCachedSelectorOptions } from '@cbridge-utils/reselect';
import { authStoreSelector } from '../auth.selector';
import { ClientFeature } from '../feature.constant';

/**
 * True when at least one of the given features is enabled (not in the token's excludedScope).
 */
export const isAnyFeatureEnabledSelector = createCachedSelector(
  [
    path(authStoreSelector).excludedScope(),
    prop<{ features: ClientFeature[] }>().features(),
  ],
  (excludedScope, features): boolean => {
    const excluded = excludedScope ?? [];
    return features.some((feature) => !excluded.includes(feature));
  },
)({
  ...createDefaultCachedSelectorOptions(),
  keySelector: (_, { features }: { features: ClientFeature[] }) => features.join(','),
});
